import { render, staticRenderFns } from "./skuPromotion.vue?vue&type=template&id=4dea4ef8&scoped=true&"
import script from "./skuPromotion.vue?vue&type=script&lang=js&"
export * from "./skuPromotion.vue?vue&type=script&lang=js&"
import style0 from "./skuPromotion.vue?vue&type=style&index=0&id=4dea4ef8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea4ef8",
  null
  
)

export default component.exports